import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { User } from './user.model';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';

import { DateUtils } from 'ng-jhipster';

@Injectable()
export class UserService extends AbstractEntityService {
    protected resourceUrl = 'api/users';
    protected resourceSearchUrl = 'api/_search/users';
    protected resourceCountUrl = 'api/_search/count/users';

    constructor(protected http: HttpClient, private dateUtils: DateUtils) { super(http); }

    create(user: User): Observable<User> {
        return this.http.post<User>(this.resourceUrl, user);
    }

    update(user: User): Observable<User> {
        return this.http.put<User>(this.resourceUrl, user);
    }

    find(login: string): Observable<User> {
        return this.http.get<User>(`${this.resourceUrl}/${login}`);
    }

    findByStudentId(id: number): Observable<User> {
        return this.http.get<HttpResponse<User>>(`${this.resourceUrl}/from-student/${id}`)
                        .map((res: HttpResponse<User>) => res.body);
    }

    queryUnmanaged(req?: any): Observable<HttpResponse<User[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<User[]>>(`${this.resourceUrl}/unmanaged`, options);
    }

    query(req?: any): Observable<HttpResponse<User[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<User[]>>(this.resourceUrl, options);
    }

    search(req?: any): Observable<HttpResponse<User[]>> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map((res: HttpResponse<User[]>) => this.convertResponse(res))
            ;
    }

    private convertResponse(res: HttpResponse<User[]>): any {
        let jsonResponse: any = res.body;
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].createdDate = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].dateOfBirth);
            jsonResponse[i].lastModifiedDate = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].dateOfBirth);
        }
        res.clone({body: jsonResponse});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/user/user.service.ts